import { AccountsPage, AccountsPageConfig } from './accounts.page';
import { LoginPage, LoginPageConfig } from './auth/login.page';
import { SSOMigratePage, SSOMigratePageConfig } from './auth/migrate.page';
import { CollectionHistoryPage, CollectionHistoryPageConfig } from './collection.history.page';
import { DashPoleLoading, DashPoleLoadingConfig } from './dashboard/pole.loading.page';
import { DashPoleStatus, DashPoleStatusConfig } from './dashboard/pole.status.page';
import { ComEdEsriPageConfig } from './externalPages/comed.esri.page';
import { ForgotPasswordPage, ForgotPasswordPageConfig } from './forgot.password.page';
import { FormEditNewPage, FormEditNewPageConfig } from './form.edit.new.page';
import { FormEditPage, FormEditPageConfig } from './form.edit.page';
import { FormListPage, FormListPageConfig } from './form.list.page';
import { CSVFileImportPage, CSVFileImportPageConfig } from './import/import.page';
import { LogoutPage, LogoutPageConfig } from './logout.page';
import { MissingPage, MissingPageConfig } from './missing.page';
import { OrgSearchConfig, OrgSearchPage } from './org.search.page';
import type { IkeLinkConfig, IkePage, IkePageName } from './page';
import { PhotoMeasurePage, PhotoMeasurePageConfig } from './photomeasure.page';
import { RootPage, RootPageConfig } from './root.page';
import { TagMapPage, TagMapPageConfig } from './tag.map.page';
import { TopologicalEditorPage, TopologicalEditorPageConfig } from './topological.editor.page';

export interface IkePageEntry {
	config: IkeLinkConfig;
	page?: new () => IkePage;
}

const pages: IkePageEntry[] = [
	// !! Internal Pages !!

	{ config: RootPageConfig, page: RootPage },

	// Authentication
	{ config: LoginPageConfig, page: LoginPage },
	{ config: LogoutPageConfig, page: LogoutPage },
	{ config: ForgotPasswordPageConfig, page: ForgotPasswordPage },
	{ config: SSOMigratePageConfig, page: SSOMigratePage },

	// Listed (order matters)
	{ config: TagMapPageConfig, page: TagMapPage },
	{ config: FormListPageConfig, page: FormListPage },
	{ config: AccountsPageConfig, page: AccountsPage },
	{ config: CSVFileImportPageConfig, page: CSVFileImportPage },

	// Form
	{ config: FormEditPageConfig, page: FormEditPage },
	{ config: FormEditNewPageConfig, page: FormEditNewPage },

	// Collection
	{ config: PhotoMeasurePageConfig, page: PhotoMeasurePage },
	{ config: CollectionHistoryPageConfig, page: CollectionHistoryPage },

	// Org search
	{ config: OrgSearchConfig, page: OrgSearchPage },

	// Dashboard
	{ config: DashPoleStatusConfig, page: DashPoleStatus },
	{ config: DashPoleLoadingConfig, page: DashPoleLoading },

	// Topological editor page
	{ config: TopologicalEditorPageConfig, page: TopologicalEditorPage },

	// Misc
	{ config: MissingPageConfig, page: MissingPage },

	// !! External Pages !!
	{ config: ComEdEsriPageConfig },
];

export const PageRegistry = {
	pages,
	getConfig(name: IkePageName): IkeLinkConfig {
		for (const page of pages) {
			if (page.config.name === name) {
				return page.config;
			}
		}

		return null;
	},
};
